import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function Latest() {
  const latest = [...comics].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt)).slice(0, 8);

  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500/15 px-3 py-1 text-xs font-semibold text-primary-500">
            <i className="ri-flashlight-fill"></i> 新章速递
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl text-foreground-950">最近更新</h2>
          <p className="mt-2 text-sm text-foreground-500">最新章节第一时间同步，追更不错过</p>
        </div>
        <Link
          to="/comics"
          className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-400 whitespace-nowrap"
        >
          全部更新 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {latest.map((c) => (
          <Link
            key={c.id}
            to={`/comic/${c.id}`}
            className="group flex items-center gap-3 rounded-xl bg-background-100 p-3 ring-1 ring-background-200/50 transition-colors hover:bg-background-200"
          >
            <div className="relative h-20 w-14 shrink-0 overflow-hidden rounded-md">
              <img
                src={c.cover}
                alt={`${c.title} 最新章节`}
                title={c.title}
                loading="lazy"
                className="h-full w-full object-cover"
              />
              <span className="absolute bottom-0 left-0 right-0 bg-black/50 py-0.5 text-center text-[9px] text-foreground-950">
                {c.updatedAt}
              </span>
            </div>
            <div className="min-w-0 flex-1">
              <h4 className="truncate text-sm font-bold text-foreground-950 group-hover:text-primary-500">
                {c.title}
              </h4>
              <p className="mt-1 truncate text-xs text-primary-500">{c.latest}</p>
              <p className="mt-1 flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-eye-line"></i> {c.views}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}